import { CRMApiAdapter } from '../adapters/CRMApiAdapter';
import { CRMModel } from '../models/CRM';
import { Filters } from '../models/Filters';

export interface Page {
  orders: CRMModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: CRMApiAdapter) {}

  async getAll(): Promise<CRMModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    return this.apiAdapter.getCRMPaginated(filters);
  }

  async exportCRMExcel(filters: Filters = {}): Promise<string> {
    // Este método está deprecado, usar exportCRMOrders en su lugar
    // Mantenido por compatibilidad
    return this.apiAdapter.exportCRMExcel(filters);
  }
}
